import { render } from "./ModalArticle.vue?vue&type=template&id=0a3cacf6&scoped=true"
import script from "./ModalArticle.vue?vue&type=script&lang=js"
export * from "./ModalArticle.vue?vue&type=script&lang=js"

import "./ModalArticle.vue?vue&type=style&index=0&id=0a3cacf6&scoped=true&lang=css"

import exportComponent from "/vercel/path0/Source Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a3cacf6"]])

export default __exports__